import React from 'react';
import {SelectField, SelectFieldItem, TextField, tokens} from '@sail/ui';
import {useIntl} from '@sail/intl';
import {getStore, setValue} from 'src/v2/state/store';
import {Text, Banner} from 'src/v2/components/common';
import {clearErrorBanner} from 'src/v2/components/error/handleError';
import {messages} from 'src/v2/components/directDeposit/refundAddressMessages';

const DISABLED_COLOR = tokens.color.neutral[400].toString();

export const RefundMethodSelector = () => {
  const intl = useIntl();
  const store = getStore();

  const {refundMethod, customRefundAddress, selectedNetwork} =
    store.useSelector((state) => ({
      refundMethod: state.directDeposit.refundMethod,
      customRefundAddress: state.directDeposit.customRefundAddress,
      selectedNetwork: state.directDeposit.selectedDirectDepositNetwork,
    }));

  const handleSelectionChange = (key: React.Key) => {
    if (key === 'setNewRefundAddress') {
      setValue((state) => {
        state.directDeposit.refundMethod = 'setNewRefundAddress';
        state.directDeposit.customRefundAddress = '';
        state.directDeposit.isRefundAddressApplied = false;
      });
      return;
    }

    if (key === 'sendToPaymentAddress') {
      setValue((state) => {
        state.directDeposit.refundMethod = 'sendToPaymentAddress';
        state.directDeposit.customRefundAddress = '';
        state.directDeposit.isRefundAddressApplied = false;
      });
      clearErrorBanner();
    }
  };

  return (
    <>
      <SelectField
        label={
          <Text type="input">
            {intl.formatMessage(messages.refundMethodLabel)}
          </Text>
        }
        selectedKey={refundMethod ?? undefined}
        placeholder={intl.formatMessage(messages.selectRefundMethod)}
        onSelectionChange={handleSelectionChange}
        size="small"
        subviews={{
          button: {
            css: {
              fontSize: '14px',
              lineHeight: '20px',
              fontWeight: 400,
              color: refundMethod ? 'text' : DISABLED_COLOR,
            },
          },
        }}
      >
        <SelectFieldItem id="sendToPaymentAddress">
          <Text type="body">
            {intl.formatMessage(messages.sendToPaymentAddress)}
          </Text>
        </SelectFieldItem>
        <SelectFieldItem id="setNewRefundAddress">
          <Text type="body">
            {intl.formatMessage(messages.setNewRefundAddress)}
          </Text>
        </SelectFieldItem>
      </SelectField>

      {refundMethod === 'sendToPaymentAddress' ? (
        <Banner
          variant="warning"
          message={intl.formatMessage(messages.exchangeWarning)}
        />
      ) : null}

      {refundMethod === 'setNewRefundAddress' && selectedNetwork ? (
        <>
          <TextField
            label={intl.formatMessage(messages.newRefundAddressLabel)}
            type="text"
            value={customRefundAddress}
            onChange={(e) => {
              setValue((state) => {
                state.directDeposit.customRefundAddress = e.target.value;
              });
            }}
            placeholder={intl.formatMessage(
              messages.newRefundAddressPlaceholder,
            )}
          />

          <Banner
            variant="warning"
            message={intl.formatMessage(messages.networkMismatchDisclaimer)}
          />
        </>
      ) : null}
    </>
  );
};
